import React, { memo, useEffect, useContext } from "react";
import { Redirect, Route, Switch, useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { context } from '../../context';

import MainApp from "./MainApp";
import SignIn from "../SignIn";
import SignUp from "../SignUp";


import '../../sass/app.scss';

const App = (props) => {

  const { state, actions } = useContext(context);
  const { initURL, authUser } = state

  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();

  console.log("VER_route_data")
  console.log(location)
  console.log(history)
  console.log(match)
  console.log("VER_route_data")

  useEffect(() => {
    actions.setPathname(location.pathname)
  }, [location])

  //set the themeColor and its styles
  useEffect(() => {
    console.log("UseEffect_App_themecolor")
    let link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = `/css/${"DARK_BLUE"}.css`;  //This line is changed, this comment is for explaination purpose.
    // link.href = `/css/${themeColor}.css`;  //This line is changed, this comment is for explaination purpose.

    link.className = 'gx-style';
    document.body.appendChild(link);
  }, []);



  useEffect(() => {
    if (initURL === '') {
      actions.setInitUrl(location.pathname)
    }

    document.body.classList.remove('boxed-layout');
    document.body.classList.remove('framed-layout');
    document.body.classList.add('full-layout');
    document.body.classList.remove('full-scroll');
    document.body.classList.remove('horizontal-layout');

  }, []);

  useEffect(() => {
    if (location.pathname === '/') {
      if (authUser === null) {
        history.push('/signin');
      } else if (initURL === '' || initURL === '/' || initURL === '/signin') {
        history.push('/social-apps/profile');
      } else {
        history.push(initURL);
      }
    }
  }, [authUser, initURL, location, history]);

  console.log("DESDE_index_App")
  return (
    <Switch>
      <Route exact path='/signin' component={SignIn} />
      {/* <Route exact path='/signup' component={SignUp} /> */}
      <RestrictedRoute path={`${match.url}`} authUser={authUser} location={location}
        component={MainApp} />
    </Switch>
  )
};
export default memo(App);

const RestrictedRoute = ({ component: Component, location, authUser, ...rest }) =>
  <Route
    {...rest}
    render={
      props =>
        authUser ?
          <Component {...props} />
          : <Redirect
            to={{
              pathname: '/signin',
              state: { from: location }
            }}
          />
    }
  />;
